// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background-color: #1a2a3a;
  color: white;
  padding: 1rem 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-logo {
  height: 70px;
  width: auto;
  margin-right: 15px;
}

.header-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
}

.header-nav ul {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 1rem 0 0 0;
  flex-wrap: wrap;
  gap: 1rem;
}

.header-nav a {
  color: white;
  text-decoration: none;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.header-nav a:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

@media (min-width: 768px) {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .header-nav ul {
    margin: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".header {\n  background-color: #1a2a3a;\n  color: white;\n  padding: 1rem 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.header-brand {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.header-logo {\n  height: 70px;\n  width: auto;\n  margin-right: 15px;\n}\n\n.header-title {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.header-nav ul {\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 1rem 0 0 0;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.header-nav a {\n  color: white;\n  text-decoration: none;\n  padding: 0.5rem;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n}\n\n.header-nav a:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n@media (min-width: 768px) {\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .header-nav ul {\n    margin: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
